module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"payment_exprie_header":"$tชำระเงินก่อนกำหนดหมดอายุ","selected_plan":"Plan Selected","bank_name":"Bank Name","total":"Total"},"th":{"payment_exprie_header":"ชำระเงินก่อนกำหนดหมดอายุ","selected_plan":"แผนที่ที่เลือก","bank_name":"ธนาคารผู้ออกบัตร","total":"รวม"}}')
  delete Component.options._Ctor
}
